var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-row',{staticClass:"my-6",attrs:{"title":"Total Earnest Money Being Held","no_border":true}},[_c('input-money',{attrs:{"name":"total_earnest_money_held","value":_vm.total_held,"read_only":true,"tabindex":"-1"}})],1),_vm._v(" "),_c('div',{staticClass:"border-b border-gray-400"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }